/**
 * HubAdmin Endpoints Index
 * All HubAdmin-specific endpoints
 */

export * from './engagement.endpoints';
export * from './master-data.endpoints';
export * from './rewards.endpoints';
export * from './schemes.endpoints';
export * from './settings.endpoints';
export * from './target-achievements.endpoints';
export * from './tds.endpoints';
export * from './user-management.endpoints';
export * from './adhoc.endpoints';
export * from './approvals.endpoints';
export * from './qr-management.endpoints';
export * from './report.endpoints';

// Named exports for convenience
export { MASTER_DATA_ENDPOINTS } from './master-data.endpoints';
export {
  ROLE_ENDPOINTS,
  ROLE_SETTINGS_ENDPOINTS,
  USER_ENDPOINTS,
  ENTITY_ENDPOINTS,
  USER_SUPERVISOR_MAPPING_ENDPOINTS,
  DEACTIVATE_USERS_ENDPOINTS,
} from './user-management.endpoints';
export { SCHEMES_ENDPOINTS } from './schemes.endpoints';
export {
  TARGET_ACHIEVEMENTS_ENDPOINTS,
  POINT_STRUCTURE_ENDPOINTS,
  TARGET_ENDPOINTS,
  TARGET_QUARTER_ENDPOINTS,
  TARGET_CYCLE_ENDPOINTS,
  BRANDS_ENDPOINTS,
} from './target-achievements.endpoints';
export { TDS_ENDPOINTS } from './tds.endpoints';
export {
  ENGAGEMENT_ENDPOINTS,
  USER_ROLE_ENDPOINTS,
  CONFIG_ENDPOINTS,
} from './engagement.endpoints';
export {
  REWARDS_ENDPOINTS,
  REWARD_CATEGORY_ENDPOINTS,
  INSTANT_VOUCHER_ENDPOINTS,
  REWARD_PRODUCT_ENDPOINTS,
} from './rewards.endpoints';
export { ADHOC_ENDPOINTS } from './adhoc.endpoints';
export { APPROVALS_ENDPOINTS } from './approvals.endpoints';
export { REPORT_ENDPOINTS } from './report.endpoints';
export { QR_ENDPOINTS } from './qr-management.endpoints';
